import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="19.856" height="23.948" viewBox="0 0 19.856 23.948">
        <g transform="translate(0.841 0.75)">
            <path id="Path_4" data-name="Path 4" d="M20.174,22.83H2L3.817,7H18.357Z" transform="translate(-2 -0.381)" fill="none" stroke="#111" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.5"/>
            <path id="Path_5" data-name="Path 5" d="M8,10.928V5.412A4.224,4.224,0,0,1,11.977,1h0a4.224,4.224,0,0,1,3.977,4.412v5.516" transform="translate(-2.89 -1)" fill="none" stroke="#111" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1.5"/>
        </g>
    </svg>;


}
